/**
 * Gráfico chico «Por hora» del detalle de una campaña en vivo: enviados, entregados y leídos por
 * hora desde que empezó (hasta 14 días). Sin horas con datos no se dibuja nada.
 */

import { CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import type { FilaHora } from "../../types.estadisticas";
import { COLORES } from "../../logic/estadisticas";
import { ESTILO_TOOLTIP, Leyenda } from "./comun";

const SERIES: { clave: keyof FilaHora; label: string; color: string }[] = [
  { clave: "enviados", label: "Enviados", color: COLORES.enviados },
  { clave: "entregados", label: "Entregados", color: COLORES.entregados },
  { clave: "leidos", label: "Leídos", color: COLORES.leidos },
];

const etiquetaHora = (iso: string) => {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleString("es-AR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
};

export function GraficoPorHora({ serie }: { serie: FilaHora[] | null | undefined }) {
  const datos = (serie || []).map((f) => ({ ...f, etiqueta: etiquetaHora(f.hora) }));
  if (!datos.some((f) => (Number(f.enviados) || 0) > 0)) return null;
  return (
    <div className="space-y-2">
      <Leyenda items={SERIES.map((s) => ({ color: s.color, label: s.label, linea: true }))} />
      <div style={{ width: "100%", height: 160 }}>
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={datos} margin={{ top: 8, right: 8, bottom: 0, left: -12 }}>
            <CartesianGrid stroke={COLORES.grilla} vertical={false} />
            <XAxis dataKey="etiqueta" tick={{ fontSize: 10, fill: COLORES.eje }} tickLine={false} axisLine={false} minTickGap={24} />
            <YAxis allowDecimals={false} tick={{ fontSize: 10, fill: COLORES.eje }} tickLine={false} axisLine={false} width={44} />
            <Tooltip {...ESTILO_TOOLTIP} formatter={(v) => Number(v).toLocaleString("es-AR")} />
            {SERIES.map((s) => (
              <Line key={String(s.clave)} type="monotone" dataKey={String(s.clave)} name={s.label} stroke={s.color} strokeWidth={2} dot={false} isAnimationActive={false} />
            ))}
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

export default GraficoPorHora;
